<template>
  <v-card>
    <template v-if="isGenerating">
      <v-card-title class="headline grey lighten-2">
        Gerando PDF
      </v-card-title>
      <v-card-text class="pa-4 text-center">
        <v-progress-circular
            indeterminate
            color="primary"
            size="64"
        ></v-progress-circular>
        <p class="mt-4">
          Aguarde enquanto geramos sua solicitação.
        </p>
        <p class="caption">
          (Este processo pode demorar alguns minutos)
        </p>
      </v-card-text>
    </template>

    <template v-else-if="isReady">
      <v-card-title class="headline grey lighten-2">
        Download Pronto
        <v-spacer></v-spacer>
        <v-btn icon @click="hide">
          <i class="fas fa-times"></i>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-4 text-center">
        <i
            class="fas fa-check-circle"
            style="font-size: 48px; color: #4caf50"
        ></i>
        <p class="mt-4">
          O arquivo já está disponível no botão abaixo.
        </p>
      </v-card-text>
      <v-card-actions class="px-4 pb-4">
        <v-btn
            color="success"
            block
            large
            :href="downloadUrl"
            target="_blank"
            @click="hide"
        >
          <i class="fas fa-download mr-2"></i>
          Abrir Arquivo
        </v-btn>
      </v-card-actions>
    </template>

    <template v-else-if="hasError">
      <v-card-title class="headline grey lighten-2">
        Erro
        <v-spacer></v-spacer>
        <v-btn icon @click="hide">
          <i class="fas fa-times"></i>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-4 text-center">
        <i
            class="fas fa-exclamation-triangle"
            style="font-size: 48px; color: #ff5252"
        ></i>
        <p class="mt-4">
          {{ error.message || 'Ocorreu um erro ao gerar seu arquivo.' }}
        </p>
        <v-btn color="primary" @click="generate" class="mt-2">
          Tentar Novamente
        </v-btn>
      </v-card-text>
    </template>
  </v-card>
</template>

<script>
import PdfExportService from "@/services/PdfExportService";

export default {
  name: "PdfHandler",
  props: {
    url: {
      type: String,
      required: true
    },
    filters: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      isGenerating: false,
      isReady: false,
      hasError: false,
      downloadUrl: null,
      error: {
        message: null,
      },
    };
  },
  mounted() {
    this.generate();
  },
  methods: {
    async generate() {
      this.isGenerating = true;
      this.hasError = false;
      this.isReady = false;
      this.error.message = null;

      try {
        const pendingId = await PdfExportService.generatePdf(this.url, this.filters);

        this.downloadUrl = await PdfExportService.waitForPdfGeneration(pendingId);

        this.isReady = true;
      } catch (err) {
        console.error("PdfHandler Error:", err);
        this.error.message = err.message || 'Ocorreu um erro inesperado durante a geração.';
        this.hasError = true;
        this.$emit("show-snackbar", this.error.message, "error");
      } finally {
        this.isGenerating = false;
      }
    },
    hide() {
      this.$emit("close");
    },
  },
};
</script>
